import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  max-width: 512px;

  h2 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
  }

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`
